import {Button, Dialog} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {forwardRef, ReactElement, useCallback, useImperativeHandle, useState} from "react";
import {COLORS} from "../../constants/constants";
interface ActionButton {
  label: string;
  action: () => void;
}
export interface IActiveFilterDialogProps {
  message: string;
  icon: ReactElement<any, any>;
  title: string;
  actionButton?: ActionButton;
}
export interface IActiveFilterDialogRef {
  onOpen: () => void;
  onClose: () => void;
}
const ActiveFilterDialog = forwardRef<IActiveFilterDialogRef, IActiveFilterDialogProps>((props, ref) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClickAction = useCallback(() => {
    setIsOpen(false);
    props.actionButton?.action();
  }, [props.actionButton]);

  useImperativeHandle(ref, () => ({
    onClose,
    onOpen
  }));
  if (isOpen)
    return (
      <DialogContainer isOpen={isOpen} onClose={onClose} enforceFocus={false} portalClassName="active-filter-dialog">
        <DialogHeader>
          <Title role="dialog-header">
            {props.icon}
            {props.title}
          </Title>
          <Button variant="minimal" icon="cross" onClick={onClose} data-testid="dialog-close-button" />
        </DialogHeader>
        <DialogBody>
          <Message role="dialog-message">{props.message}</Message>
        </DialogBody>
        <DialogFooter>
          <DialogButton data-testid="close-button" onClick={onClose}>
            Close
          </DialogButton>
          {props.actionButton && (
            <DialogButton intent="primary" data-testid="action-button" onClick={handleClickAction}>
              {props.actionButton.label}
            </DialogButton>
          )}
        </DialogFooter>
      </DialogContainer>
    );
  else return null;
});

export default ActiveFilterDialog;

ActiveFilterDialog.displayName = "ActiveFilterDialog";

const DialogContainer = styled(Dialog)`
  font-family: Roboto;
  position: absolute;
  top: 45px;
  left: 25px;
  width: 390px;
  height: fit-content;

  background-color: white;
  border-radius: 8px;
`;
const DialogHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 12px 0 24px;
`;

const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 24px 0;
`;

const DialogFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 24px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
`;
const Message = styled.div`
  font-size: 14px;
`;

const DialogButton = styled(Button)`
  padding: 4px 12px;
  border-radius: 8px;
  height: 32px;
  color: ${COLORS.BLUE};

  &.bp5-button.bp5-intent-primary {
    background: ${COLORS.BG_GRADIENT_DARK_BLUE};
    color: ${COLORS.WHITE};
  }

  :hover {
    opacity: 0.95;
  }

  :active {
    opacity: 0.8;
  }
`;
